<template>
  <fts-client-modal
    append-content-class="list-view-preference-modal__body"
    title="User Preference"
    class="fts-list-view-preference-modal"
    ref="ftsClientModal"
  >
    <!-- header:icon -->
    <i slot="icon" class="fts-icon-cog" />
    <!-- body -->
    <template #body>
      <!-- header -->
      <div class="preference-column-header" v-if="formData && formData.length">
        <div>
          <div class="preference-column-header-title">All ({{formData.length}})</div>
        </div>
        <div class="preference-column-action">
          <fts-toggle-switch
            :label="false"
            mat-class
            :size="14"
            v-model="selectAll"
          />
        </div>
      </div>
      <!-- columns -->
      <draggable
        v-bind="dragOptions"
        handle=".preference-column-handle"
        :list="formData"
      >
        <div
          v-for="column in formData"
          :key="column.id"
          class="preference-column"
        >
          <font-awesome-icon
            :icon="['fas', 'grip-vertical']"
            class="preference-column-handle"
          />
          <fts-label-group
            :item="{...column, displayName: column.label || column.displayName }"
            information
            :information-modules="workspaceModules"
            emoji
            :emoji-size="14"
            class="preference-column-information"
          />
          <div class="preference-column-action">
            <fts-toggle-switch
              :label="false"
              mat-class
              :size="14"
              v-model="column.show"
            />
          </div>
        </div>
      </draggable>  
    </template>
    <!-- footer:left -->
    <template #footerLeft>
      <fts-btn text @click="resetUserPreference">
        <font-awesome-icon :icon="['fas', 'redo-alt']" /> Reset
      </fts-btn>
    </template>
    <!-- footer:right -->
    <template #footerRight>
      <fts-btn text @click="beforeClose">
        <font-awesome-icon :icon="['fas', 'times']" /> Close
      </fts-btn>

      <fts-btn color="primary" @click="done">
        <font-awesome-icon :icon="['fas', 'check']" /> Ok
      </fts-btn>
    </template>
  </fts-client-modal>
</template>

<script>
import changesets from 'diff-json';
import draggable from 'vuedraggable';

import commons from '../commons/commons';
import { clientStore } from '../store/clientStore';

import FTSBtn from './FTSBtn';
import FTSClientModal from './FTSClientModal';
import FTSLabelGroup from './FTSLabelGroup';
import FTSToggleSwitch from './FTSToggleSwitch';

export default {
  components: {
    draggable,
    "fts-btn": FTSBtn,
    "fts-client-modal": FTSClientModal,
    "fts-label-group": FTSLabelGroup,
    "fts-toggle-switch": FTSToggleSwitch
  },
  data: () => ({
    formData: null,
    originalData: null,
    resolve: null,
    dragOptions: commons.dragOptions,
  }),
  methods: {
    async show(items) {
      this.formData = _.cloneDeep(items);

      this.formData.forEach((x) => {
        if (x["show"] === null || x["show"] === undefined)
          this.$set(x, "show", true);
      });

      return new Promise((resolve) => {
        this.resolve = resolve;
        this.$refs.ftsClientModal.show({
          beforeCloseHandler: () => {
            const diff = changesets.diff(this.formData, this.originalData);
            if (diff && diff.length) { 
              this.$modal.show("dialog", {
                title: "Confirm discard changes",
                text: "Discard all changes?",
                buttons: [
                  { title: "Cancel" },
                  {
                    title: "Discard",
                    default: true,
                    handler: () => {
                      this.$modal.hide("dialog");
                      this.reset();
                    },
                  },
                ],
              });
            } else {
              this.reset();
            }
          },
        });

        this.$nextTick(() => {
          this.originalData = _.cloneDeep(this.formData);
        });
      });
    },
    done() {
      this.resolve && this.resolve(this.formData);
      this.reset();
    },
    beforeClose() {
      this.$refs.ftsClientModal.beforeClose();
    },
    reset() {
      this.$refs.ftsClientModal.close();
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    resetUserPreference() {
      this.resolve && this.resolve(null);
      this.reset();
    }
  },
  computed: {
    selectAll: {
      get() {
        return this.formData && this.formData.every(x => x.show);
      },
      set(val) {
        this.formData.forEach(x => { x.show = val});
      }
    },
    workspaceModules() {
      return clientStore.getters.workspaceModules;
    }
  }
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-list-view-preference-modal {
  .list-view-preference-modal__body {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .preference-column-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
    padding: 0 0.75rem 0.375rem 1.5rem;
    .preference-column-header-title {
      font-weight: 500;
    }
  }
  .preference-column {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
    padding: 0.375rem 0.75rem 0.375rem 1.5rem;
    border-radius: 0.25rem;
    &:hover {
      background-color: rgba(var(--fts-gray-100-rgb), 0.75);
      .preference-column-handle {
        display: block;
      }
    }
    .preference-column-handle {
      position: absolute;
      left: 0.575rem;
      display: none;
      font-size: 0.75rem;
      color: var(--fts-default);
      cursor: grab;
    }
    .preference-column-information {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
    .preference-column-action {
      margin-left: 0.75rem;
    }
  }
}
</style>